export default class freeSampleForm {
  constructor() {  
    $(function(){
		var wffCusPlaceHolder = $('.subscribe-block .forgot-password-form .form-group').find('.help-block').text();
		$('.subscribe-block .forgot-password-form .form-group,.subscribe-block .update-password-form .form-group').find('.help-block').hide();
		$('.subscribe-block .forgot-password-form .form-group input[type="email"]').attr('placeholder',wffCusPlaceHolder);
		
		var upDatePassPlaceHolder = $('.subscribe-block .update-password-form .form-group input[data-val-length]').next('.help-block').text();
		$('.subscribe-block .update-password-form .form-group input[type="password"]').attr('placeholder',upDatePassPlaceHolder);
		var upDateConPassPlaceHolder = $('.subscribe-block .update-password-form .form-group input[data-val-equalto-other]').next('.help-block').text();
		$('.subscribe-block .update-password-form .form-group input[data-val-equalto-other]').attr('placeholder',upDateConPassPlaceHolder);
		$('form.free-sample-form').submit(function( event ) {
			dataLayer.push({
				'event' : 'uaevent',
				'eventCategory': 'sample',
				'eventAction': 'requested',
				'eventLabel': ''
			});
			event.preventDefault();
		});
    });
  }
}
